import styled from 'styled-components';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import { useMemo } from 'react';
import { usePreviewFlow } from '../../../hooks/usePreviewFlow';
import { useTranslation } from 'react-i18next';

const StyledDropdownForPdfSwitch = styled(Dropdown)`
  width: 167px;
`;

const PdfSwitchContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

const PdfSwitchDropdown = () => {
  const { activeFileId, attachedFiles, updateActiveFileId, scrollToTop } =
    usePreviewFlow();
  const { t } = useTranslation();

  const pdfOptions = useMemo(() => {
    return (
      attachedFiles?.map((x) => {
        const fileName = x.file_name || x.fileName;
        const truncatedName =
          fileName.length > 18 ? fileName.substring(0, 15) + '...' : fileName;
        return {
          value: x._id,
          label: truncatedName,
        };
      }) || []
    );
  }, [attachedFiles]);

  const selectedPDF = () => {
    return pdfOptions.find((x) => x.value === activeFileId);
  };

  const selectedPDFIndex = () => {
    return pdfOptions.findIndex((x) => x.value === activeFileId) + 1;
  };

  const handleChange = (e) => {
    updateActiveFileId(e.value);
    scrollToTop();
  };

  return (
    <PdfSwitchContainer>
      {pdfOptions.length > 1 ? (
        <>
          Previewing file {selectedPDFIndex()} of {pdfOptions.length}
          <StyledDropdownForPdfSwitch
            clearable={false}
            searchable={false}
            options={pdfOptions}
            value={selectedPDF()}
            placeholder={t('PDF Name')}
            size={Dropdown.size.SMALL}
            className="dropdown-stories-styles_with-chips"
            onChange={handleChange}
          />
        </>
      ) : null}
    </PdfSwitchContainer>
  );
};

export default PdfSwitchDropdown;
